import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchInHouseUsersData } from "../../redux/reducers/dropdownApiSlice";
import { useFormik } from "formik";
import { expenseSchema } from "../../schema/schema";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import {
  add_expense_process_manager,
  update_expense_process_manager,
} from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";

const ExpenseProcessForm = ({
  token,
  closeModal,
  isEdit,
  getProcessExpenseCategories,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { inhouseUsers } = useSelector((state) => state.dropdown);

  const formik = useFormik({
    initialValues: {
      user_id:
        isEdit && rowData?.user_id
          ? { label: rowData.user_name, value: rowData.user_id }
          : "",
      role_type:
        isEdit && rowData?.role_type
          ? { label: rowData.role_type, value: rowData.role_type }
          : "",
      isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
      superProcessManager: isEdit
        ? rowData?.super_process_manager === 1
          ? true
          : false
        : false,
    },
    validationSchema: expenseSchema,
    onSubmit: async (values) => {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit
        ? update_expense_process_manager
        : add_expense_process_manager;
      const payload = {
        user_id: values?.user_id?.value,
        role_type: values?.role_type?.value,
        status: values?.isActive ? "active" : "inactive",
        super_process_manager: values?.superProcessManager ? 1 : 0,
        ...(rowData?.uid && { uid: rowData.uid }),
      };
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );
      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        getProcessExpenseCategories();
        closeModal();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  useEffect(() => {
    dispatch(
      fetchInHouseUsersData({
        token: token,
        qps: "user_types=admin",
        pageNo: 1,
        limit: 100,
      })
    );
  }, []);

  const roleType = [
    {
      label: "Accountant",
      value: "accountant",
    },
    {
      label: "Approval Manager",
      value: "approval_manager",
    },
  ];

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Process Manager`}
        onClose={closeModal}
        onClick={formik.handleSubmit}
        // isLoading={postPutLoadingFormData || loading}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="catName" className={`formInputLabel `}>
              Select Admin <span className="required">*</span>
            </label>

            <SelectDropdownLabel
              options={inhouseUsers?.length > 0 ? inhouseUsers : []}
              value={formik?.values?.user_id}
              setSelectedOption={(selectedValue) =>
                formik.setFieldValue("user_id", selectedValue)
              }
              name="Select admin"
            />

            {formik.touched.user_id && formik.errors.user_id ? (
              <div className="error-message">{formik.errors.user_id}</div>
            ) : null}
          </div>
          <div className="formInputBox">
            <label htmlFor="catName" className={`formInputLabel `}>
              Select Role Type <span className="required">*</span>
            </label>

            <SelectDropdownLabel
              options={roleType?.length > 0 ? roleType : []}
              value={formik?.values?.role_type}
              setSelectedOption={(selectedValue) =>
                formik.setFieldValue("role_type", selectedValue)
              }
              name="Select Role Type"
            />

            {formik.touched.role_type && formik.errors.role_type ? (
              <div className="error-message">{formik.errors.role_type}</div>
            ) : null}
          </div>

          <div className={`commonWrapper commonSwitchWrapper no-border`}>
            <Form.Check
              type="switch"
              name="isActive"
              label={formik.values.isActive ? "Active" : "Not Active"}
              checked={formik.values.isActive}
              onChange={() =>
                formik.setFieldValue("isActive", !formik.values.isActive)
              }
            />
            <Form.Check
              type="switch"
              name="superProcessManager"
              label={"Super Process Manager"}
              checked={formik.values.superProcessManager}
              onChange={() =>
                formik.setFieldValue(
                  "superProcessManager",
                  !formik.values.superProcessManager
                )
              }
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ExpenseProcessForm;
